import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import {action} from 'redux/helpers';
import types from './types';
import api from '../../../../api';
import ApiService from '../../../../api/ApiService';
import i18n from '../../../../i18n';
import {dispatchAsync} from 'redux/common';
import {DialogCallbacks} from 'types/common';
import {DiplomatKey} from 'types/DiplomatKey';
import {IDiplomatObject} from 'types/DiplomatObject';
import {IPartner} from 'types/partners';
import {IProxyServer} from 'types/ProxyServer';
import {Transport} from 'types/transport/Abstract/AbstractTransport';
import {layoutActions} from 'features/layout/redux';
import {DialogTypes} from 'common/names';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';
import history from 'redux/history';
import {FormOnSubmitHelpers, FormOnSubmitOutsideHelpers} from 'components/hook-form/Formik';

const testTransport = (data: Transport) =>
   dispatchAsync(api.transport, types.TEST_TRANSPORT, {
      getMethod: ApiService.postSecureJson,
      data,
      onSuccess: (resp: any, dispatch?: ThunkDispatch<{}, {}, AnyAction>) => {
         dispatch &&
            dispatch(
               layoutActions.openSubDialog({
                  id: DialogTypes.AlertDialog.id,
                  title: i18n.t('Test'),
                  content: i18n.t('Test successful.'),
               })
            );
      },
      onError: (err: any, dispatch?: ThunkDispatch<{}, {}, AnyAction>) => {
         dispatch &&
            dispatch(
               layoutActions.openSubDialog({
                  id: DialogTypes.AlertDialog.id,
                  title: i18n.t('Test'),
                  content: i18n.t('Test failed.'),
               })
            );
      },
   });

const updatePartner = (data: IPartner, helpers?: FormOnSubmitHelpers<any>) =>
   action(types.UPDATE_PARTNER.SAGA, {data, helpers});

export default {
   getData: (id?: string, objectType?: DiplomatObjectTypeUnion) =>
      action(types.GET_DATA.SAGA, {id, objectType}),
   postKey: (values: DiplomatKey) => dispatchAsync(api.keys, types.POST_KEY),
   sendData: (
      dialogType: string,
      values: IDiplomatObject,
      callbacks?: FormOnSubmitHelpers<IDiplomatObject>
   ) => action(types.SEND_DATA.SAGA, {_dialogType: dialogType, values}, callbacks),
   flushData: () => async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
      dispatch(action(types.GET_DATA.SUCCESS, {}));
      history.push('/');
   },

   getProxies: () => dispatchAsync(`${api.proxies}`, types.GET_PROXIES),
   addProxy: (data: IProxyServer, cbs?: DialogCallbacks) =>
      dispatchAsync(api.proxies, types.ADD_PROXY, {
         ...cbs,
         getMethod: ApiService.postSecureJson,
         data,
      }),
   deleteProxy: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(api.proxies + `/${id}`, types.DELETE_PROXY, {
         ...cbs,
         getMethod: ApiService.deleteSecureJson,
      }),
   editProxy: (data: IProxyServer, cbs?: DialogCallbacks) =>
      dispatchAsync(api.proxies + `/${data.id}`, types.UPDATE_PROXY, {
         ...cbs,
         getMethod: ApiService.putSecureJson,
         data,
      }),
   testTransport,
   updatePartner,

   persistDirtyValuesGetter: (
      id: string,
      objectType: string,
      helpers: FormOnSubmitOutsideHelpers<any>
   ) =>
      action(types.PERSIST_DIRTY_VALUES_GETTER, {
         id,
         objectType,
         ...helpers,
      }),
   flushDirtyValuesGetter: (id: string, objectType: string) =>
      action(types.FLUSH_DIRTY_VALUES_GETTER, {
         id,
         objectType,
      }),
};
